<template>
  <a-modal
    ref="createModal"
    title="新建工序"
    :width="800"
    :visible="visible"
    :maskClosable="false"
    @cancel="close"
    @ok="confirm"
    :confirmLoading="confirmLoading"
  >
    <div class="table-page-operator-wrapper">
      <a-button @click="addLine()" type="primary">新增行</a-button>
    </div>
    <a-table
      ref="modalTable"
      :columns="columns"
      :data-source="typeList"
      :pagination="false"
      row-key="indexId"
    >
      <span slot="organizationCodeTitle">
        <i class="toRequired">*</i>加工组织
      </span>
      <span slot="organizationCode" slot-scope="text, record" class="organization-code-container">
        <global-select
          :value.sync="record.organizationCode"
          selectType="selectAssemble"
          requestApi="/system/user/inventOrgList"
          :selectItem="{ value: 'realValue', label: 'label' }"
          :dropdown-match-select-width="false"
          :allowClear="false"
          :assembleLabel="true"
        />
      </span>
      <!-- 工序编码 -->
      <span slot="operationCodeTitle">
        <i class="toRequired">*</i>工序编码
      </span>
      <template slot="operationCode" slot-scope="text, record">
        <a-input v-model="record.operationCode" />
      </template>
      <!-- 工序说明 -->
      <template slot="operationDesc" slot-scope="text, record">
        <a-input v-model="record.operationDesc" />
      </template>
      <template slot="capacity" slot-scope="text, record">
        <a-input-number :min="0" v-model="record.capacity" class="capacity-input"/>
      </template>
      <!-- 产能/时 -->
      <!-- <template slot="unitCapacity" slot-scope="text, record">
        <a-input-number v-model="record.unitCapacity" :min="0" />
      </template> -->
      <span slot="operation" slot-scope="text, record">
        <a @click="handleDelete(typeList, record)">删除</a>
      </span>
    </a-table>
  </a-modal>
</template>

<script>
import { apiBomOperationAdd } from '@/api/mes/basedata/productionProcesses'
import { mapState } from 'vuex'
// 表单字段
export default {
  props: {},
  computed: {
    ...mapState({
      inventOrg: (state) => state.user.inventOrg
    })
  },
  data () {
    return {
      // 当前控件配置:
      confirmLoading: false,
      visible: false,
      columns: [
        {
          // title: '加工组织',
          width: 190,
          dataIndex: 'organizationCode',
          scopedSlots: { customRender: 'organizationCode', title: "organizationCodeTitle" }
        },
        {
          // title: '工序编码',
          dataIndex: 'operationCode',
          width: 150,
          scopedSlots: { customRender: 'operationCode', title: "operationCodeTitle" }
        },
        {
          title: '工序说明',
          width: 150,
          dataIndex: 'operationDesc',
          scopedSlots: { customRender: 'operationDesc' }
        },
        // {
        //   title: '产能/时',
        //   width: 150,
        //   dataIndex: 'unitCapacity',
        //   scopedSlots: { customRender: 'unitCapacity' }
        // },
        {
          title: '日产能',
          width: 80,
          dataIndex: 'capacity',
          scopedSlots: { customRender: 'capacity' }
        },
        {
          title: '操作',
          width: 100,
          dataIndex: 'operation',
          scopedSlots: { customRender: 'operation' }
        }
      ],
      typeList: []
    }
  },
  created () {},
  methods: {
    // 删除
    handleDelete (arr, record) {
      arr.forEach((item, index) => {
        if (item.indexId === record.indexId) {
          arr.splice(index, 1);
        }
      });
    },
    show () {
      this.addLine()
      this.visible = true
    },
    // 新增行
    addLine () {
      const arr = JSON.parse(JSON.stringify(this.typeList))
      const indexId = arr.length > 0 ? arr[arr.length - 1].indexId : 0
      const obj = {
        operationCode: "",
        operationDesc: "",
        // unitCapacity: "",
        operationStatus: "Y",
        indexId: Number(indexId) + 1
      }
      arr.push(obj)
      this.typeList = arr
    },
    // 关闭模态框
    close () {
      this.reset()
      this.visible = false
    },
    // 保存
    confirm () {
      let flag = false
      for (let i = 0; i < this.typeList.length; i++) {
        if (!this.typeList[i].operationCode || !this.typeList[i].organizationCode) {
          this.$message.warning('必填项不能为空！')
          flag = true
          return
        }
        // if (!this.typeList[i].unitCapacity || Number(this.typeList[i].unitCapacity) <= 0) {
        //   this.$message.warning('产能/时不能为空且需大于0')
        //   flag = true
        //   return
        // }
      }
      if (flag) {
        return false
      }
      this.confirmLoading = true
      apiBomOperationAdd(this.typeList).then(response => {
        if (response.code === 200) {
          this.$message.success('新增成功')
          // 关闭本组件
          this.visible = false
          // 调用外部刷新列表方法
          this.$emit('handle-success')
          // 刷新表单
          this.reset()
          this.confirmLoading = false
        } else {
          this.$message.error(response.msg)
          this.confirmLoading = false
        }
      }).catch(e => {
        this.confirmLoading = false
      })
    },
    // 表单重置
    reset () {
      this.typeList = []
    }
  }
}
</script>

<style scoped lang="less">
input{
  width: 150px;
}
/deep/.ant-input-number{
  width: 150px;
}
/deep/.ant-modal-body{
  height: 400px;
  overflow-y: scroll;
}
.capacity-input {
  width: 80px;
}
.organization-code-container {
  /deep/.ant-select{
    width: 100%;
  }
}
</style>
